module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Card', [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(" Nota Transaksi Giro")]), _vm._v(" "), _c('Row', {
    staticClass: "code-row-bg",
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('ButtonGroup', {
    staticClass: "custom-group-parent"
  }, [_c('Button', {
    staticClass: "custom-group"
  }, [_vm._v("Tgl. Giro")]), _vm._v(" "), _c('Date-picker', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "type": "daterange",
      "format": "yyyy-MM-dd"
    },
    on: {
      "on-change": _vm.updateFilter
    },
    model: {
      value: (_vm.filterGiroDate),
      callback: function($$v) {
        _vm.filterGiroDate = $$v
      },
      expression: "filterGiroDate"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('ButtonGroup', {
    staticClass: "custom-group-parent"
  }, [_c('Button', {
    staticClass: "custom-group"
  }, [_vm._v("Kode Nota")]), _vm._v(" "), _c('Input', {
    staticStyle: {
      "width": "250px"
    },
    on: {
      "on-keyup": _vm.updateFilter
    },
    model: {
      value: (_vm.filterNoteCode),
      callback: function($$v) {
        _vm.filterNoteCode = $$v
      },
      expression: "filterNoteCode"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('ButtonGroup', {
    staticClass: "custom-group-parent"
  }, [_c('Button', {
    staticClass: "custom-group"
  }, [_vm._v("Marking")]), _vm._v(" "), _c('Select', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "filterable": "",
      "clearable": "",
      "remote-method": _vm.getMarkingByCode,
      "loading": _vm.isLoadingMarking
    },
    on: {
      "on-change": _vm.updateFilter
    },
    model: {
      value: (_vm.markingIdSelected),
      callback: function($$v) {
        _vm.markingIdSelected = $$v
      },
      expression: "markingIdSelected"
    }
  }, _vm._l((_vm.optionMarkings), function(option) {
    return _c('Option', {
      key: option.value,
      attrs: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.label))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "2"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "icon": "ios-search",
      "disabled": !_vm.isSearchShow
    },
    on: {
      "click": _vm.getTransactionNote
    }
  }, [_c('span', [_vm._v("Cari")])])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "2"
    }
  }, [_c('Spin', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoadingMarking),
      expression: "isLoadingMarking"
    }],
    attrs: {
      "size": "large"
    }
  })], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('Card', [_c('Table', {
    attrs: {
      "columns": _vm.columnsDataTable,
      "data": _vm.transactionNoteData
    },
    on: {
      "on-selection-change": _vm.onSelectionChange
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.transactionNotePrint.length > 0),
      expression: "transactionNotePrint.length > 0"
    }],
    staticClass: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "success",
      "icon": "printer",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.modalConfirmMultiplePrint = true
      }
    }
  }, [_c('span', [_vm._v("Cetak " + _vm._s(_vm.transactionNotePrint.length) + " data")])])], 1), _vm._v(" "), _c('div', {
    ref: "sheetsDataTableList",
    attrs: {
      "id": "table-to-excel",
      "hidden": ""
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "50rem"
    },
    model: {
      value: (_vm.modalConfirmMultiplePrint),
      callback: function($$v) {
        _vm.modalConfirmMultiplePrint = $$v
      },
      expression: "modalConfirmMultiplePrint"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#f60",
      "text-align": "center"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('Icon', {
    attrs: {
      "type": "information-circled"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Konfirmasi")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "left",
      "display": "flex"
    }
  }, _vm._l((_vm.transactionNotePrint), function(data) {
    return _c('div', [_c('Tag', {
      attrs: {
        "color": "blue"
      }
    }, [_vm._v(_vm._s(data.noteCode))])], 1)
  }), 0), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "error",
      "size": "large",
      "long": "",
      "icon": "printer"
    },
    on: {
      "click": function($event) {
        return _vm.notePrint(_vm.transactionNotePrint)
      }
    }
  }, [_vm._v("Cetak")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15886f46","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/giro/GiroTransactionNote.vue
// module id = 1780
// module chunks = 1